//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SelectField',
  props: {
    value: '',
    label: String,
    name: String,
    options: Array,
    multiple: false,
    max: Number,
    error: '',
    taggable: false,
    clearable: false,
    tooltip: '',
    placeholder: '',
  },
  methods: {
    updateValue: function (value) {
      let max = this.$props.max;
      if(max && value.length > max) {
          alert('Maximaal '+max+' items');
      } else {
        this.$emit('input', value);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/SelectField.vue